import { render, staticRenderFns } from "./CpuRelationAddOrEditModal.vue?vue&type=template&id=33173437&scoped=true"
import script from "./CpuRelationAddOrEditModal.vue?vue&type=script&lang=js"
export * from "./CpuRelationAddOrEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33173437",
  null
  
)

export default component.exports